// extracted by mini-css-extract-plugin
module.exports = {"main":"global-error_main__0zsig","buttons":"global-error_buttons__Vzv87"};